module.exports = __webpack_public_path__ + "img/engagement-photo-8.060e4a5b.jpg";